import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import 'github-markdown-css';
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "二维码在线生成器及 API 服务"
    }), "\n", _jsx(_components.h2, {
      children: "如何使用"
    }), "\n", _jsx(_components.p, {
      children: "在左侧输入框中输入数据，右侧将会实时生成二维码，点击下载按钮可下载图片。"
    }), "\n", _jsx(_components.h2, {
      children: "API"
    }), "\n", _jsx(_components.p, {
      children: "本站点对二维码提供对外 API 接口，可供调用:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-bash",
        children: "# 生成二维码\n$ curl -L devtool.tech/api/qrcode?data=https://www.baidu.com\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Live Demo: ", _jsx(_components.a, {
        href: "/api/qrcode?data=https://shanyue.tech&width=200",
        children: "https://devtool.tech/api/qrcode?data=https://shanyue.tech&width=200"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "NPM"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://npm.devtool.tech/qrcode",
          children: "qrcode"
        })
      }), "\n"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-bash",
        children: "$ npm i qrcode\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "在 JS 中使用它"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "const QRCode = require('qrcode')\nconst dataurl = await QRCode.toDataURL('https://shanyue.tech')\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
